module.exports = __webpack_public_path__ + "img/gsjjlrightBox.1dbbb0b7.png";